// extracted by mini-css-extract-plugin
export default {"country":"styles_country__R7gZA","main_section":"styles_main_section__Ps-HH","left_banner":"styles_left_banner__FAD+b","right_section":"styles_right_section__JoGEK"};